import { Component, effect, inject } from '@angular/core';
import { TranslocoPipe, TranslocoService } from '@jsverse/transloco';
import { ButtonModule } from 'primeng/button';
import {
  Accommodation,
  HOTELS,
  PER_ACCOMMODATION,
} from 'src/app/trip-calculator/models/accommodation';
import { PrestationModalService } from 'src/app/trip-calculator/services/prestation-modal.service';
import { PrestationEmptyStateComponent } from '../prestation-empty-state/prestation-empty-state.component';
import { TripService } from 'src/app/trip-calculator/services/trip.service';
import { ConfirmationService } from 'primeng/api';
import { PopoverModule } from 'primeng/popover';
import { ToastModule } from 'primeng/toast';
import { SectionValidationService } from '../../../services/section-validation.service';
import { ItemValidationBadgeComponent } from '../../item-validation-badge/item-validation-badge.component';
import { CountryService } from 'src/app/trip-calculator/services/country.service';

@Component({
  selector: 'app-accommodation-section',
  imports: [
    ButtonModule,
    TranslocoPipe,
    PrestationEmptyStateComponent,
    PopoverModule,
    ToastModule,
    ItemValidationBadgeComponent,
  ],
  templateUrl: './accommodation-section.component.html',
})
export class AccommodationSectionComponent {
  tripService = inject(TripService);
  prestationModalService = inject(PrestationModalService);
  translocoService = inject(TranslocoService);
  confirmationService = inject(ConfirmationService);
  sectionValidationService = inject(SectionValidationService);
  countryService = inject(CountryService);
  accommodations?: Accommodation[];
  hasAccommodation: boolean = false;

  constructor() {
    effect(() => {
      const trip = this.tripService.trip();
      if (trip) {
        this.accommodations = trip.accommodations;
        this.hasAccommodation = trip.accommodations.length > 0;
      }
    });
  }
  addAccommodation = () => {
    this.prestationModalService.addAccommodation();
  };
  editAccommodation(index: number) {
    this.prestationModalService.editAccommodation(index);
  }
  deleteAccommodation(index: number) {
    this.tripService.deleteAccommodation(index)?.subscribe();
  }
  confirmDelete(index: number) {
    const message = this.translocoService.translate(
      'confirmation.deleteAccommodation',
    );
    const header = this.translocoService.translate(
      'confirmation.deleteConfirmation',
    );
    this.confirmationService.confirm({
      message: message,
      header: header,
      icon: 'pi pi-exclamation-triangle',
      acceptLabel: this.translocoService.translate('yes'),
      rejectLabel: this.translocoService.translate('no'),
      accept: () => this.deleteAccommodation(index),
    });
  }
  displayPerRoom(accommodation: Accommodation) {
    return accommodation.type ? HOTELS.includes(accommodation.type) : false;
  }

  onItemValidationBadgeClick(event: {
    scope: 'transport' | 'accommodation' | 'activity' | 'meal';
    index: number;
  }) {
    if (event.scope === 'accommodation') {
      this.prestationModalService.editAccommodation(event.index);
    }
  }

  displayPeoplePerRoomOrAccommodation(accommodation: Accommodation) {
    return (
      HOTELS.includes(accommodation.type) ||
      PER_ACCOMMODATION.includes(accommodation.type)
    );
  }
}
